import React from 'react'
import { components } from 'cng-web-lib'
import { useParams } from 'react-router-dom'

import pathMap from 'src/paths/PathMap_CeCAdmin'
import CecUomConfigApiUrls from 'src/apiUrls/CecUomConfigApiUrls'
import FormProperties from './FormProperties'

const {
  form: {
    CngEditFormButtonSection
  },
  button: { CngSecondaryButton },
  CngGridItem
} = components

const { form: { CngEditForm } } = components

function EditPage({ history, showNotification }) {
  const { id } = useParams()

  return (

    <CngEditForm
      fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
      shouldDisableEnterToSubmit
      showNotification={showNotification}
      bodySection={
        <FormProperties.Fields
          disabled={false}
          showNotification={showNotification}
          mode={"edit"}
          id={id}
        />
      }
      renderButtonSection={() => (
        <CngEditFormButtonSection>
          <CngGridItem>
            <CngSecondaryButton
              onClick={() => { history.push(pathMap.CEC_UOM_CONVERSION_LIST_VIEW) }}>
              {'Cancel'}
            </CngSecondaryButton>
          </CngGridItem>
        </CngEditFormButtonSection>
      )}
      formikProps={FormProperties.formikProps}
      toClientDataFormat={FormProperties.toClientDataFormat}
      toServerDataFormat={FormProperties.toServerDataFormat}
      fetch={{
        url: CecUomConfigApiUrls.List_UOM_CONVERSION
      }}
      update={{
        url: CecUomConfigApiUrls.EDIT_UOM_CONVERSION,
        successRedirect: pathMap.CEC_UOM_CONVERSION_LIST_VIEW
      }}
      id={id}
    />
  )

}

export default EditPage
